import { cx } from './cx';

export interface BrandMarkProps {
  /** Rendered size in CSS pixels; the image is the 192px PWA icon, so it stays sharp up to that. */
  size: number;
  className?: string;
}

/**
 * The go-badge, from the same PNG the home-screen icon uses.
 *
 * An <img> rather than inline SVG: the badge's letters are outlined glyphs, a
 * couple of kilobytes of path data that would otherwise ship inside every
 * route chunk, while the PNG is already cached from the manifest. Decorative —
 * every place it appears sits next to the name in text.
 */
export function BrandMark({ size, className }: BrandMarkProps) {
  return (
    <img
      className={cx('brand-mark', className)}
      src="/icons/icon-192.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}
